import { Language, Lightning, Router, Utils } from "@lightningjs/sdk";
import { bgColor } from "../../Lib/Common";
import Button from "../../Components/Button";
import { getOS } from "../../Lib/Security";

export class ErrorPage extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      collision: true,
      Background: {
        rect: true,
        w: 1920,
        h: 1080,
        color: bgColor,
      },
      Logo: {
        mountX: 0.5,
        mountY: 1,
        x: 960,
        y: 600,
        src: Utils.asset("images/logo.png"),
      },
      Text: {
        mount: 0.5,
        x: 960,
        y: 720,
        text: {
          text: Language.translate("error_page_title"),
          fontFace: "Regular",
          fontSize: 34,
          textColor: 0xbbffffff,
        },
      },
      Button: {
        mount: 0.5,
        x: 960,
        y: 820,
        w: 400,
        type: Button,
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 20 },
        ref: "HomeButton",
        action: "$home",
        label: "Inicio",
      }
    };
  }
  
  _handleAppClose() {
    const sistemaOperativo = getOS();
    if(sistemaOperativo === "LG/SmartTV"){
      webOS.platformBack();
    }else if(sistemaOperativo === "Samsung TV"){
      window.tizen.application.getCurrentApplication().exit();
    }else{
      this.application.closeApp();
      window.location.href = "about:blank";
    }
  }
  _handleBack() {
    const sistemaOperativo = getOS();
    if(sistemaOperativo === "LG/SmartTV"){
      webOS.platformBack();
    }else if(sistemaOperativo === "Samsung TV"){
      window.tizen.application.getCurrentApplication().exit();
    }else{
      this.application.closeApp();
      window.location.href = "about:blank";
    }
  }
  _handleEnter() {
    this.$home();
  }

  $home() {
    Router.root();
  }

  _getFocused() {
    return this.tag("HomeButton");
  }
  
  _handleClick(target, coords) {
    this.$home();
  }
  _init() {
    this.tag("Background")
      .animation({
        duration: 15,
        repeat: -1,
        actions: [
          {
            t: "",
            p: "color",
            v: {
              0: { v: 0xff416381 },
              0.5: { v: 0xff122b49 },
              0.8: { v: 0xff527794 },
            },
          },
        ],
      })
      .start();
  }
}
